import * as yup from 'yup'
import { defineMessages, IntlShape } from 'react-intl'

const messages = defineMessages({
  nameRequired: {
    id: 'loyalty.newRule.form.name.required',
    defaultMessage: 'The name is required'
  },
  nameMin: {
    id: 'loyalty.newRule.form.name.max',
    defaultMessage: 'The name should be at least 2 characters'
  },
  nameMax: {
    id: 'loyalty.newRule.form.name.max',
    defaultMessage: 'The name can be up to 100 characters'
  },
  descriptionMax: {
    id: 'loyalty.newRule.form.description.max',
    defaultMessage: 'The description can be up to 500 characters'
  },
  descriptionMin: {
    id: 'loyalty.newRule.form.description.min',
    defaultMessage: 'The description should be at least 2 characters'
  },
  detailsRequired: {
    id: 'loyalty.newRule.form.details.required',
    defaultMessage: 'The details is required'
  },
  detailsMax: {
    id: 'loyalty.newRule.form.details.max',
    defaultMessage: 'The details can be up to 600 characters'
  },
  detailsMin: {
    id: 'loyalty.newRule.form.details.min',
    defaultMessage: 'The details should be at least 2 characters'
  },
  validAtRequired: {
    id: 'loyalty.newRule.form. validAt.required',
    defaultMessage: 'The field is required'
  },
  validAtMax: {
    id: 'loyalty.newRule.form.validAt.max',
    defaultMessage: 'The value can be up to 250 characters'
  },
  validAtMin: {
    id: 'loyalty.newRule.form.validAt.min',
    defaultMessage: 'The value should be at least 2 characters'
  },
  howToGetItRequired: {
    id: 'loyalty.newRule.form.howToGetIt.required',
    defaultMessage: 'The field is required'
  },
  howToGetItMax: {
    id: 'loyalty.newRule.form.howToGetIt.max',
    defaultMessage: 'The value can be up to 250 characters'
  },
  howToGetItMin: {
    id: 'loyalty.newRule.form.howToGetIt.min',
    defaultMessage: 'The value should be at least 2 characters'
  },
  rewardRequired: {
    id: 'loyalty.newRule.form.reward.required',
    defaultMessage: 'The reward is required'
  },
  requiredSalesChannels: {
    id: 'loyalty.newRule.form.salesChannels.required',
    defaultMessage: 'You need to select at least one valid sales channel'
  },
  originRequired: {
    id: 'loyalty.newRule.form.origin.required',
    defaultMessage: 'The origin is required'
  },
  destinationRequired: {
    id: 'loyalty.newRule.form.destination.required',
    defaultMessage: 'The destination is required'
  },
  requiredSegments: {
    id: 'loyalty.newRule.form.segments.required',
    defaultMessage: 'You need to select at least one valid segment'
  },
  requiredCities: {
    id: 'loyalty.newRule.form.cities.required',
    defaultMessage: 'You need to select at least one valid city'
  }
})

export const schema = (intl: IntlShape): yup.AnyObjectSchema => {
  return yup.object().shape({
    ruleName: yup
      .string()
      .required(intl.formatMessage(messages.nameRequired))
      .min(2, intl.formatMessage(messages.nameMin))
      .max(100, intl.formatMessage(messages.nameMax)),
    ruleDescription: yup
      .string()
      .min(2, intl.formatMessage(messages.descriptionMin))
      .max(500, intl.formatMessage(messages.descriptionMax)),
    ruleDetails: yup
      .string()
      .required(intl.formatMessage(messages.detailsRequired))
      .min(2, intl.formatMessage(messages.detailsMin))
      .max(600, intl.formatMessage(messages.detailsMax)),
    ruleValidAt: yup
      .string()
      .required(intl.formatMessage(messages.validAtRequired))
      .min(2, intl.formatMessage(messages.validAtMin))
      .max(250, intl.formatMessage(messages.validAtMax)),
    ruleHowToGetIt: yup
      .string()
      .required(intl.formatMessage(messages.howToGetItRequired))
      .min(2, intl.formatMessage(messages.howToGetItMin))
      .max(250, intl.formatMessage(messages.howToGetItMax)),
    salesChannels: yup.array().min(1, intl.formatMessage(messages.requiredSalesChannels)),
    cityOrigins: yup.array().when('allCitiesAndSegments', {
      is: false,
      then: yup.array().min(1, intl.formatMessage(messages.requiredCities))
    }),
    cityDestinations: yup.array().when('allCitiesAndSegments', {
      is: false,
      then: yup.array().min(1, intl.formatMessage(messages.requiredCities))
    }),
    segments: yup.array().when(['allCitiesAndSegments', 'allSegments'], {
      is: (allCitiesAndSegments: boolean, allSegments: boolean) => !allCitiesAndSegments && !allSegments,
      then: yup.array().min(1, intl.formatMessage(messages.requiredSegments))
    }),
    ruleEffects: yup.object().shape({
      reward: yup.object().shape({
        id: yup.string().required(intl.formatMessage(messages.rewardRequired))
      })
    })
  })
}
